// @ts-nocheck
import React from 'react';
import { Heading, Text } from '@chakra-ui/react';

const ScoreBoard = ({ score }) => {
  return (
    <div>
      <Heading as="h5" size="xs" color="blue.500"></Heading>
      <Text fontSize="14px" color="blue.500" fontWeight="normal">Current Score: {score !== undefined ? score : "Loading..."}</Text>
    </div>
  );
};

export default ScoreBoard;
